class WebSocketService {
  constructor() {
    this.ws = null
    this.reconnectInterval = 3000
    this.reconnectTimer = null
    this.listeners = new Map()
    this.isConnected = false
    this.currentUserId = null
  }

  connect(userId) {
    if (this.ws && this.ws.readyState === WebSocket.OPEN) {
      return
    }

    this.currentUserId = userId

    let wsBaseUrl = process.env.VUE_APP_WS_URL
    if (!wsBaseUrl) {
      const wsProtocol = window.location.protocol === 'https:' ? 'wss:' : 'ws:'
      wsBaseUrl = `${wsProtocol}//${window.location.host}/ws/chat`
    }
    const wsUrl = `${wsBaseUrl}?userId=${userId}`

    try {
      this.ws = new WebSocket(wsUrl)

      this.ws.onopen = () => {
        console.log('WebSocket connected')
        this.isConnected = true
        this.emit('connected', null)
        if (this.reconnectTimer) {
          clearTimeout(this.reconnectTimer)
          this.reconnectTimer = null
        }
      }

      this.ws.onmessage = (event) => {
        try {
          const data = JSON.parse(event.data)
          if (data.type === 'message') {
            this.emit('message', data.message)
          } else if (data.type === 'error') {
            this.emit('error', data.error)
          }
        } catch (e) {
          console.error('WebSocket message parse error:', e)
        }
      }

      this.ws.onclose = () => {
        console.log('WebSocket disconnected')
        this.isConnected = false
        this.emit('disconnected', null)
        this.scheduleReconnect()
      }

      this.ws.onerror = (error) => {
        console.error('WebSocket error:', error)
        this.emit('error', error)
      }
    } catch (e) {
      console.error('WebSocket connection error:', e)
      this.scheduleReconnect()
    }
  }

  scheduleReconnect() {
    if (this.reconnectTimer) {
      return
    }
    this.reconnectTimer = setTimeout(() => {
      if (this.currentUserId) {
        console.log('Attempting to reconnect WebSocket...')
        this.connect(this.currentUserId)
      }
      this.reconnectTimer = null
    }, this.reconnectInterval)
  }

  disconnect() {
    if (this.reconnectTimer) {
      clearTimeout(this.reconnectTimer)
      this.reconnectTimer = null
    }
    if (this.ws) {
      this.ws.close()
      this.ws = null
    }
    this.isConnected = false
    this.currentUserId = null
  }

  sendMessage(senderId, receiverId, content) {
    if (!this.ws || this.ws.readyState !== WebSocket.OPEN) {
      console.error('WebSocket is not connected')
      return false
    }

    const data = {
      type: 'chat',
      senderId: senderId,
      receiverId: receiverId,
      content: content
    }

    try {
      this.ws.send(JSON.stringify(data))
      return true
    } catch (e) {
      console.error('WebSocket send error:', e)
      return false
    }
  }

  on(event, callback) {
    if (!this.listeners.has(event)) {
      this.listeners.set(event, [])
    }
    this.listeners.get(event).push(callback)
  }

  off(event, callback) {
    if (!this.listeners.has(event)) {
      return
    }
    const callbacks = this.listeners.get(event)
    const index = callbacks.indexOf(callback)
    if (index > -1) {
      callbacks.splice(index, 1)
    }
  }

  emit(event, data) {
    if (!this.listeners.has(event)) {
      return
    }
    this.listeners.get(event).forEach(callback => {
      try {
        callback(data)
      } catch (e) {
        console.error('Event listener error:', e)
      }
    })
  }
}

export default new WebSocketService()
